<template>
  <div>
    <el-divider />
    <h3>Additional Details</h3>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title required>University</el-input-title>
        <el-form-item prop="meta.university">
          <el-select class="mt-05" v-model="value.meta.university" placeholder="Select your university">
            <el-option v-for="university in universities" :key="university" :label="university" :value="university" />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col
        v-if="value.meta.university === 'Other - please specify'"
        :span="24"
        :md="12"
        class="mt-20"
      >
        <el-input-title required>Please specify your university</el-input-title>
        <el-form-item prop="meta.universityOther">
          <el-input
            class="mt-05"
            v-model="value.meta.universityOther"
            placeholder="Please specify"
          ></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title required>Student Number</el-input-title>
        <el-form-item prop="meta.studentNumber">
          <el-input
            class="mt-05"
            v-model="value.meta.studentNumber"
            placeholder="Enter your student number"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import playerDetails from '@/mixins/player-details';

export default {
  name: 'UnisportExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  mounted() {
    // Ensure meta object exists
    if (!this.value.meta) {
      this.$set(this.value, 'meta', {});
    }
  },
  data() {
    return {
      universities: [
        'Adelaide University',
        'Australian Catholic University',
        'Australian College of Physical Education',
        'Avondale University College',
        'Bond University',
        'Central Queensland University',
        'Charles Sturt University',
        'Curtin University',
        'Deakin University',
        'Edith Cowan University',
        'Federation University Australia',
        'Flinders University',
        'Griffith University',
        'International College of Management Sydney',
        'James Cook University',
        'La Trobe University',
        'Macquarie University',
        'Monash University',
        'Murdoch University',
        'Queensland University of Technology',
        'RMIT University',
        'Southern Cross University',
        'Swinburne University of Technology',
        'The Australian National University',
        'The University of Melbourne',
        'The University of Newcastle',
        'The University of Notre Dame Australia',
        'The University of Queensland',
        'The University of Sydney',
        'The University of Western Australia',
        'University of Canberra',
        'University of New England',
        'University of Southern Queensland',
        'University of Tasmania',
        'University of Technology Sydney',
        'University of the Sunshine Coast',
        'University of Wollongong',
        'UNSW Sydney',
        'Victoria University',
        'Western Sydney University',
        'Other - please specify'
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.el-autocomplete,
.el-select,
.el-input {
  width: 100%;
}

el-input-title {
  margin-bottom: 1rem !important;
}
</style>
